/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Fokus_OkInputs */

const en_tut_fokus_ok = /** @type {(inputs: Tut_Fokus_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone in the room sees the same timer and which cycle is running, and status objects read **Sedang bekerja**, **Selesai / sehat**, **Perlu perhatian**, or **Bermasalah**.`)
};

const id_tut_fokus_ok = /** @type {(inputs: Tut_Fokus_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua orang di ruang melihat timer yang sama beserta penanda siklus keberapa yang sedang berjalan, dan objek status menampilkan **Sedang bekerja**, **Selesai / sehat**, **Perlu perhatian**, atau **Bermasalah**.`)
};

/**
* | output |
* | --- |
* | "Everyone in the room sees the same timer and which cycle is running, and status objects read **Sedang bekerja**, **Selesai / sehat**, **Perlu perhatian**, or..." |
*
* @param {Tut_Fokus_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_fokus_ok = /** @type {((inputs?: Tut_Fokus_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Fokus_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_fokus_ok(inputs)
	return en_tut_fokus_ok(inputs)
});